import { NativeDateAdapter } from "@angular/material/core";
import { MatDateFormats } from "@angular/material/core";
import { convertToUtcDate, getDaysInMonth } from "./date-helpers";
import { Injectable } from "@angular/core";

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if(displayFormat === 'input'){
            return date.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            })
        }
        return super.format(date, displayFormat);
    }


    parse(value: any): Date | null {
        if(value === "" || value === null){
            return null;
        }

        if(!/^\d\d\/\d\d\/\d\d\d\d$/.test(value)){
            return new Date('invalid');
        }

        const dateParts = value.split('/');

        dateParts[1] -= 1;

        if(dateParts[1] > 11 || dateParts[1] < 0){
            return new Date('invalid');
        }

        if(getDaysInMonth(dateParts[2], dateParts[1]) < dateParts[0]){
            return new Date('invalid');
        }
        
         return convertToUtcDate(new Date(+dateParts[2],+dateParts[1],+dateParts[0],0));
    }
}

export const APP_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
    },
    display: {
        dateInput: 'input',
        monthYearLabel: { month: 'long', year: 'numeric' },
        dateA11yLabel: { month: 'long', year: 'numeric', day: 'numeric' },
        monthYearA11yLabel: { month: 'long', year: 'numeric' }
    }
}